import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, FormGroup, FormLabel, FormControl, Container, Card, Row, Col, Toast, ToastContainer } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

export default function UpdatePatient() {
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('');
  const { patientId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`https://project01-n0pn.onrender.com/api/patient/getpatient/${patientId}`)
      .then((response) => {
        setPatient(response.data);
        setLoading(false);
      })
      .catch((error) => {
        alert('Error loading patient.');
        setLoading(false);
      });
  }, [patientId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatient((prevPatient) => ({
      ...prevPatient,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.put(`https://project01-n0pn.onrender.com/api/patient/updatepatient/${patientId}`, patient)
      .then((response) => {
        setToastMessage('Patient updated successfully!');
        setToastVariant('warning');
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false); // Hide the toast after 5 seconds
          navigate('/view-all-patients'); // Navigate to view-all-patients after 5 seconds
        }, 5000);
      })
      .catch((error) => {
        setToastMessage('Error updating patient.');
        setToastVariant('warning');
        setShowToast(true);
        console.error('Error updating patient:', error);
      });
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!patient) {
    return <p>No data found for this patient.</p>;
  }

  return (
    <Container>
      <Card className='card-container'>
        <h1 className='header'>Update Patient</h1>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <FormGroup controlId="formName">
                <FormLabel>Name</FormLabel>
                <FormControl
                  type="text"
                  name="name"
                  value={patient.name}
                  onChange={handleChange}
                  placeholder="Enter name"
                  required
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="formAddress">
                <FormLabel>Address</FormLabel>
                <FormControl
                  type="text"
                  name="address"
                  value={patient.address}
                  onChange={handleChange}
                  placeholder="Enter address"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <FormGroup controlId="formAge">
                <FormLabel>Age</FormLabel>
                <FormControl
                  type="number"
                  name="age"
                  value={patient.age}
                  onChange={handleChange}
                  placeholder="Enter age"
                  required
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="formGender">
                <FormLabel>Gender</FormLabel>
                <FormControl
                  as="select"
                  name="gender"
                  value={patient.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </FormControl>
              </FormGroup>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <FormGroup controlId="formEmail">
                <FormLabel>Email</FormLabel>
                <FormControl
                  type="email"
                  name="email"
                  value={patient.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                  required
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="forPatientNIC">
                <FormLabel>NIC</FormLabel>
                <FormControl
                  type="text"
                  name="patient_nic"
                  value={patient.patient_nic}
                  onChange={handleChange}
                  placeholder="Enter NIC"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col>
              <FormGroup controlId="formPatientDOB">
                <FormLabel>Date of birth</FormLabel>
                <FormControl
                  type="date"
                  name="patient_dob"
                  value={patient.patient_dob}
                  onChange={handleChange}
                  placeholder="Enter date of birth"
                  required
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup controlId="formContactNumber">
                <FormLabel>Contact Number</FormLabel>
                <FormControl
                  type="text"
                  name="contact_number"
                  value={patient.contact_number}
                  onChange={handleChange}
                  placeholder="Enter contact number"
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Button className="update-button" variant="warning" type="submit">
            Update Patient
          </Button>
        </Form>
      </Card>
      <ToastContainer position="top-end" className="p-3" style={{marginTop:"35px"}}>
        <Toast onClose={() => setShowToast(false)} show={showToast} className='toast' bg={toastVariant} delay={3000} autohide>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}